import { Workbook } from "exceljs";
import * as fs from "file-saver";

export class OthersContactsImportSpreedSheetGenerator {
    workbook = new Workbook();
    worksheets = { cover: {}, contacts: {} };
    textCover = {
        h1: `Essa planilha é um modelo para importar em lote todos os contatos que não estejam relacionados as suas empresas, por exemplo, leads e outros contatos para ações de marketing e comercial.`,
        h2: `Para iniciar, basta apenas cadastrar os nomes das empresas, nomes e e-mails dos contatos na aba "Dados" dessa planilha.`,
        h3: `Caso queira importar contatos que são de empresas da sua carteira, use uma outra planilha modelo, localizada na funcionalidade de "Contatos".`
    };
    headerConfigs = [
        { cell: "A1", label: "Nome da Empresa", columns: ["A"] },
        { cell: "B1", label: "Nome do Contato", columns: ["B"] },
        { cell: "C1", label: "E-mail do contato", columns: ["C"] }
    ];
    cellBorder = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
    };
    cellFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "cfdbe6" }
    };
    editableColumns = ["A", "B", "C"];
    constructor() {}

    async execute({ accountingId }) {
        if (!accountingId) return { response: false };
        this.setDocumentInfo();
        this.createCover();
        await this.createContactsPage();
        await this.saveAs();
        return { response: true };
    }

    setDocumentInfo() {
        this.workbook.creator = "Nucont";
        this.workbook.created = new Date();
    }

    createCover() {
        this.worksheets.cover = this.workbook.addWorksheet("Resumo", {
            pageSetup: { paperSize: 9, orientation: "landscape" },
            views: [{ showGridLines: false }]
        });
        const cells = [
            { row: 5, start: "C5", end: "S5", text: this.textCover.h1 },
            { row: 7, start: "C7", end: "S7", text: this.textCover.h2 },
            { row: 9, start: "C9", end: "S9", text: this.textCover.h3 }
        ];
        for (const cell of cells) {
            this.worksheets.cover.mergeCells(`${cell.start}:${cell.end}`);
            const row = this.worksheets.cover.getRow(cell.row);
            row.height = 30;
            const worksheetCell = this.worksheets.cover.getCell(cell.start);
            worksheetCell.font = {
                name: "Arial",
                size: 12
            };
            worksheetCell.alignment = {
                horizontal: "left",
                vertical: "middle",
                wrapText: true
            };
            worksheetCell.value = cell.text;
            worksheetCell.protection = {
                locked: true
            };
        }
    }

    async createContactsPage() {
        this.worksheets.contacts = this.workbook.addWorksheet("Dados", {
            views: [{ showGridLines: true }]
        });
        this.setHeader();
        this.unlockCells();
        await this.worksheets.contacts.protect("@nucontxxxx", {
            selectUnlockedCells: true,
            formatCells: true,
            formatColumns: true
        });
    }

    setHeader() {
        for (const header of this.headerConfigs) {
            const columns = header.columns;
            for (const column of columns) {
                this.worksheets.contacts.getColumn(column).width = 25;
            }
            const cell = this.worksheets.contacts.getCell(header.cell);
            cell.fill = this.cellFill;
            cell.value = header.label;
            cell.border = this.cellBorder;
            cell.protection = {
                locked: true
            };
        }
    }

    unlockCells() {
        const maxContacts = new Array(50);
        for (const [index] of maxContacts.entries()) {
            for (const column of this.editableColumns) {
                const cell = this.worksheets.contacts.getCell(
                    `${column}:${index + 2}`
                );
                cell.border = this.cellBorder;
                cell.font = { size: 12, name: "Arial" };
                cell.alignment = { horizontal: "left" };
                cell.protection = {
                    locked: false
                };
            }
        }
    }

    async saveAs() {
        return new Promise((resolve) => {
            let fileName = `Nucont - Importacao de Outros Contatos.xlsx`;
            this.workbook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                fs.saveAs(blob, fileName);
                resolve(true);
            });
        });
    }
}
